module.exports = __webpack_public_path__ + "static/img/9.cd663a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/9.png
// module id = gcHh
// module chunks = 0